import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function CVMP2023() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms for Images and 3D Objects</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 30 - Dec. 1, 2023.</BlockSubtitle>
          <BlockText>Herbert Potechius, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>Over the past decades, an overwhelming number of scientific contributions have been published related to the topic of color transfer, where the color statistic of an image is transferred to another image. Recently, this idea was further extended to 3D point clouds. Due to the fact that the results are normally evaluated subjectively, an objective comparison of multiple algorithms turns out to be difficult. Therefore, this paper introduces the <b>ColorTransferLab</b>, a web based test bed that offers a large set of state-of-the-art color transfer implementations. Furthermore, it allows users to integrate their implementations with the ultimate goal of providing a library of state-of-the-art algorithms for the scientific community. This test bed can manipulate both 2D images, 3D point clouds and textured triangle meshes, and it allows us to objectively evaluate and compare color transfer algorithms by providing a large set of objective metrics. As part of ColorTransferLab, we are introducing a comprehensive dataset of freely available images. This dataset comprises a diverse range of content with a wide array of color distributions, sizes, and color depths which helps in appropriately evaluating color transfer. Its comprehensive nature makes it invaluable for accurately evaluating color transfer methods.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="200px 200px 200px 200px 200px 200px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://dl.acm.org/doi/10.1145/3626495.3626509")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://dl.acm.org/doi/10.1145/3626495.3626509")}>arXiv</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://github.com/hpotechius/ColorTransferLab")}>Code</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Datasets/ColorTransfer')}>Dataset 1</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Datasets/CTPublication')}>Dataset 2</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Applications/ColorTransferLab')}>Tool</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default CVMP2023;
